
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"remove\":true,\"id\":1}!css?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-0537fe3e!postcss!sass!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./TaskDetailsMaking.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./TaskDetailsMaking.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-0537fe3e!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./TaskDetailsMaking.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./views/copyrighter/taskManagement/TaskDetailsMaking.vue
// module id = 1084
// module chunks = 0